//ATS joyride docs @ https://wiki.poslovi.live/en/ats/joyride

const tourActions = {
  TOUR_SET_INDEX: 'TOUR_SET_INDEX',
  TOUR_RESET: 'TOUR_RESET',

  TOUR_RUN_SECTION: 'TOUR_RUN_SECTION',
  TOUR_ADD_SECTION: 'TOUR_ADD_SECTION',
  TOUR_REMOVE_SECTION: 'TOUR_REMOVE_SECTION',
  TOUR_REMOVE_FINISHED: 'TOUR_REMOVE_FINISHED',
  TOUR_SET_SECTION_PARAMS: 'TOUR_SET_SECTION_PARAMS',

  RUN: 'RUN',
  STOP: 'STOP',
  CANCELL: 'CANCELL',
  RUN_CANCEL_TOUR: 'RUN_CANCEL_TOUR',
  RUN_CANCEL_TOUR_CLOSE: 'RUN_CANCEL_TOUR_CLOSE',

  VERIFY_CHECKPOINT_START: 'VERIFY_CHECKPOINT_START',
  VERIFY_CHECKPOINT_DONE: 'VERIFY_CHECKPOINT_DONE',
  VERIFY_CHECKPOINT_ERROR: 'VERIFY_CHECKPOINT_ERROR',
  VERIFY_CHECKPOINT_CANCELLED: 'VERIFY_CHECKPOINT_CANCELLED',

  VERIFY_CHECKPOINT_WITH_NOTIFICATION_START: 'VERIFY_CHECKPOINT_WITH_NOTIFICATION_START',
  VERIFY_CHECKPOINT_WITH_NOTIFICATION_DONE: 'VERIFY_CHECKPOINT_WITH_NOTIFICATION_DONE',
  VERIFY_CHECKPOINT_WITH_NOTIFICATION_ERROR: 'VERIFY_CHECKPOINT_WITH_NOTIFICATION_ERROR',
  VERIFY_CHECKPOINT_WITH_NOTIFICATION_CANCELLED: 'VERIFY_CHECKPOINT_WITH_NOTIFICATION_CANCELLED',

  VERIFY_CHECKPOINT_FLAG_START: 'VERIFY_CHECKPOINT_FLAG_START',
  VERIFY_CHECKPOINT_FLAG_DONE: 'VERIFY_CHECKPOINT_FLAG_DONE',
  VERIFY_CHECKPOINT_FLAG_ERROR: 'VERIFY_CHECKPOINT_FLAG_ERROR',
  CLEAR_CHECKPOINT_FLAG: 'CLEAR_CHECKPOINT_FLAG',
  MARK_CHECKPOINT_SEEN: 'MARK_CHECKPOINT_SEEN',
  SET_CHECKPOINT_NEXT_STEP: 'SET_CHECKPOINT_NEXT_STEP',
  SET_RESERVED_SECTION: 'SET_RESERVED_SECTION',

  FINISH_CHECKPOINT: 'FINISH_CHECKPOINT',

  resetTour: () => ({
    type: tourActions.TOUR_RESET,
  }),

  removeSection: (section) => ({
    type: tourActions.TOUR_REMOVE_SECTION,
    payload: section,
  }),

  removeFinished: (section) => ({
    type: tourActions.TOUR_REMOVE_FINISHED,
    payload: section,
  }),

  verifyCheckpoint: (section, contentId) => ({
    type: tourActions.VERIFY_CHECKPOINT_START,
    payload: {
      section,
      contentId,
    },
  }),

  verifyCheckpointWithNotification: (section, contentId) => ({
    type: tourActions.VERIFY_CHECKPOINT_WITH_NOTIFICATION_START,
    payload: {
      section,
      contentId,
    },
  }),

  verifyCheckpointFlag: (section, contentId) => ({
    type: tourActions.VERIFY_CHECKPOINT_FLAG_START,
    payload: {
      section,
      contentId,
    },
  }),

  clearCheckpointFlag: (section) => ({
    type: tourActions.CLEAR_CHECKPOINT_FLAG,
    payload: section,
  }),

  /**
   * Remembers on the client that the user saw a section, independently of whether reporting it to
   * /finishOnboarding succeeded. Kept across the project, application and selection pages.
   */
  markCheckpointSeen: (section) => ({
    type: tourActions.MARK_CHECKPOINT_SEEN,
    payload: section,
  }),

  setCheckpointNextStep: (section, nextStep) => ({
    type: tourActions.SET_CHECKPOINT_NEXT_STEP,
    payload: { section, nextStep },
  }),

  /** While a section is reserved, other sections' checkpoints don't start their tours. */
  setReservedSection: (section, reserved) => ({
    type: tourActions.SET_RESERVED_SECTION,
    payload: { section, reserved },
  }),

  finishCheckpoint: (section) => ({
    type: tourActions.FINISH_CHECKPOINT,
    payload: {
      section,
    },
  }),

  setIndex: (index) => ({
    type: tourActions.TOUR_SET_INDEX,
    payload: index,
  }),

  addSection: (section) => ({
    type: tourActions.TOUR_ADD_SECTION,
    payload: section,
  }),

  /**
   * `options.step` is the step just shown, reported to /finishOnboarding when the section stops so
   * the backend can resume there; leave it out to close the section for good.
   * `options.onboardingSection` overrides the name sent to the backend, for sections whose key in
   * the store is not the backend's name for them.
   * `options.silent` stops without calling /finishOnboarding at all, for when the user saw nothing.
   */
  runSection: (section, state, options = {}) => ({
    type: tourActions.TOUR_RUN_SECTION,
    payload: {
      section,
      state: typeof state !== 'undefined' ? state : tourActions.RUN,
      step: options.step,
      onboardingSection: options.onboardingSection,
      silent: options.silent,
    },
  }),

  setSectionParams: (section, params) => ({
    type: tourActions.TOUR_SET_SECTION_PARAMS,
    payload: {
      section,
      params,
    },
  }),
};

export default tourActions;
